import './Login.css'
import { useState, useCallback } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import GlobalStorage from '../../GlobalStore'

import { useLoginMutation } from '../../redux/authService/authApiSlice'
import { ReactComponent as Eye } from '../../icon/hide-password.svg'
import { setAuthorized } from '../../redux/authService/authSlice'
import { Input } from '../../components/Input/Input'
import { Button } from '../../components/Button/Button'
import { Header } from '../../components/Header/Header'
import { CommunityLanguage } from '../../components/CommunityLanguage/CommunityLanguage'

export default function Login() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const [logIn] = useLoginMutation()

	const navigate = useNavigate()

	const [password, setPassword] = useState('')
	const [user, setUser] = useState('')
	const [errLogin, setErrLogin] = useState('')
	const [errPassword, setErrPassword] = useState('')
	const [passwordShown, setPasswordShown] = useState(false)
	const [openTranslator, setOpenTranslator] = useState(false)

	const handleLoginInput = useCallback((e) => {
		setErrLogin('')
		setErrPassword('')
		const value = e.target.value

		setUser(value)

		// if (value.startsWith('8')) {
		// 	setUser('+7' + user?.slice(1))
		// } else if (value.startsWith('9')) {
		// 	setUser('+7' + value)
		// } else if (value.startsWith('7')) {
		// 	const number = '+' + value
		// 	setUser(number)
		// } else if (value.startsWith('+') && value?.[1] !== '7') {
		// 	const number = '+7' + value?.slice(1)
		// 	setUser(number)
		// } else {
		// 	setUser(value)
		// }
	}, [])

	const checkFields = useCallback(() => {
		if (!user) {
			setErrLogin(t('Enter Email'))
		}

		if (!password) {
			setErrPassword(t('Enter password'))
		}

		if (!user || !password) {
			return false
		} else {
			return true
		}
	}, [user, password, t])

	const defineLogin = useCallback(() => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
		// const phoneRegex = /^(?:\+7)?(\d{10})$/

		if (emailRegex.test(user)) {
			return { email: user }
		} else {
			return { username: user }
		}

		// else if (phoneRegex.test(user)) {
		// 	return { mobile: user }
		// } 
	}, [user])

	const handleSubmit = useCallback(async (event) => {
		event.preventDefault()
		GlobalStorage.clear()

		if (errLogin || errPassword) {
			return
		}

		let body = defineLogin()

		if (!checkFields()) {
			return
		}

		try {
			body = { ...body, password: password }
			const response = await logIn(body).unwrap()

			if (response?.error) {
				return
			}

			GlobalStorage.setItem('refresh', response?.refresh)
			GlobalStorage.setItem('access', response?.access)
			GlobalStorage.setItem('authorized', true)
			dispatch(setAuthorized(true))
			setUser('')
			setPassword('')
			navigate('/communities')
		} catch (e) {
			setErrPassword(t('Incorrect password'))
			setErrLogin(
				body?.email ? t('Incorrect email') :
					body?.mobile ? t('Incorrect phone number') :
						t('Incorrect login')
			)

			console.log('Login catch error', e)
			GlobalStorage.clear()
			localStorage.setItem('wipe_reason', 'login error')
		}
	}, [errLogin, errPassword, password, defineLogin, dispatch, logIn, checkFields, t, GlobalStorage])

	const handlePassword = useCallback((e) => {
		setErrLogin('')
		setErrPassword('')
		setPassword(e.target.value)
	}, [])
	const showPassword = useCallback(() => { setPasswordShown(!passwordShown) }, [passwordShown])

	const handleOnClickLogin = useCallback(() => {
		setErrLogin('')
		setErrPassword('')
	}, [])

	const handleOnClickPassword = useCallback(() => {
		setErrPassword('')
		setErrLogin('')
	}, [])

	return (
		<>
			<Header
				className="header-container"
				title={t('Login')}
				backButton={true}
				translation={false}
				openTranslator={() => setOpenTranslator(true)}
			/>

			<div className="login__container">
				<form onSubmit={handleSubmit} className="login__form">
					<div className="login__form-input">
						{/*
						<label className="login__input-label" htmlFor="login">
							{t('Login/phone number/email')}
						</label>
						*/}

						<label className="login__input-label" htmlFor="login">
							{t('Email')} <span style={{ color: 'red' }}>*</span>
						</label>

						<div className="login__input-login">
							<Input
								value={user}
								onChange={handleLoginInput}
								onClick={handleOnClickLogin}
								type={'text'}
								id="login"
								borderColor={errLogin ? '#F20505' : ''}
								required={false}
							/>
						</div>

						{
							errLogin &&
								<p className="login__error-login">
									{errLogin}
								</p>
						}
					</div>

					<div className="login__form-input" style={{ position: 'relative' }}>
						<label className="login__input-label" htmlFor="password">
							{t('Password')} <span style={{ color: 'red' }}>*</span>
						</label>

						<div className="login__input-password">
							<Input
								value={password}
								onChange={handlePassword}
								onClick={handleOnClickPassword}
								type={passwordShown ? 'text' : 'password'}
								id="password"
								borderColor={errPassword ? '#F20505' : ''}
								required={false}
							/>
						</div>

						<Eye onClick={showPassword} className="login__input-icon" />
					</div>

					{
						errPassword &&
						<p className="login__error-password">
							{errPassword}
						</p>
					}

					<div className="login_button-submit">
						<Button type={'submit'} title={t('Sing in')} />
					</div>
				</form>

				<Link to="#" className="login__password-restoration">
					{t('Forgot your password?')}
				</Link>

				<Link to="/registration" className="registration-button">
					{t('Organizer registration')}
				</Link>
			</div>

			{
				openTranslator &&
				<CommunityLanguage onClose={() => setOpenTranslator(false)} />
			}
		</>
	)
}